import {axiosWithOutToken} from "./network.es6";
export const getNews = () => new Promise((resolve,) => {
    const post = {};
    axiosWithOutToken({url: '/api/news/', method: 'get', data: post})
        .then((response) => {
            if (response.status === 200) {
                resolve(response.data);
            }
        })
        .catch((response) => {
            reject([response])
        });
});
export const getBlog = () => new Promise((resolve,) => {
    const post = {};
    axiosWithOutToken({url: '/api/blog/', method: 'get', data: post})
        .then((response) => {
            if (response.status === 200) {
                resolve(response.data);
            }
        })
        .catch((response) => {
            reject([response])
        });
});
